import { useState } from 'react';

/**
 * Vilka rader som är utfällda i en tabell där en rad (oftast ett län) kan fällas ut till sina
 * underrader. Nyckeln är radens etikett.
 */
const useExpandedRows = () => {
  const [open, setOpen] = useState<string[]>([]);

  return {
    isOpen: (key: string) => open.includes(key),
    toggle: (key: string) =>
      setOpen((current) =>
        current.includes(key)
          ? current.filter((k) => k !== key)
          : [...current, key]
      ),
  };
};

export default useExpandedRows;
